<template>
    <div v-if="campaign.dates.content.after">
        <div class="box">
            <div class="campaign-form-title">
                {{ customizationText('tasks_step_title', 'Media Requirements') }}
            </div>

            <p>
                <span v-if="!support_email">Your tasks are listed below:</span>
                <span v-else>
                    Your tasks are listed below, if you have any questions or trouble delivering content please contact us at
                    <a :href="`mailto:${support_email}?subject=Tasks for ${campaign.title}`">
                        {{ support_email }}
                    </a>
                </span>
            </p>
        </div>

        <job-tasks
            :class="{'mb-100': !campaign.allow_upload}"
            :campaign="campaign"
            :jobs="jobs"
            :deliverable="true"
        />
    </div>

    <div v-else>
        <div class="box">
            <div class="campaign-form-title">
                {{ customizationText('tasks_step_title', 'Media Requirements') }}
            </div>

            The content delivery dates for this campaign have passed.
        </div>
    </div>
</template>

<script>
    import CampaignCustomizeMixin from '../../../../mixins/CampaignCustomizeMixin';
    import JobTasks from '../JobTasks.vue';

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'JobDeliverables',

        /**
         * The component mixins
         *
         * @type {Array}
         */
        mixins: [
            CampaignCustomizeMixin
        ],

        /**
         * The child components
         *
         * @type {Object}
         */
        components: {
            JobTasks
        },

        /**
         * The component properties
         *
         * @type {Object}
         */
        props: {
            /**
             * The campaign
             */
            campaign: {
                type:     Object,
                required: true
            },

            /**
             * The proposal jobs
             */
            jobs: {
                type:     Array,
                required: true
            }
        }
    }
</script>

